import { Component, OnInit, ViewChild, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
// import { ValidationService } from '../../../validation.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaginatePipe } from 'ngx-pagination';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioButton } from '@angular/material/radio';
// import { NgxPaginationModule } from 'ngx-pagination';
@Component({
  selector: 'app-device-versioning',
  templateUrl: './device-versioning.component.html',
  styleUrls: ['./device-versioning.component.scss'],
  standalone:true,
  imports: [MatIcon,CommonModule,NgbNavModule,NgxPaginationModule,MatButtonModule,MatRadioButton,MatIconModule,MatButtonModule]
})
export class DeviceVersioningComponent implements OnInit {
  private getDeviceAllUrl: any = BaseUrlConstantsService.ADD_DEVICE;
  private inventoryListingUrl = BaseUrlConstantsService.INVENTORYLIST;
  private deviceTypeListingUrl = BaseUrlConstantsService.DEVICE_TYPE_LIST;
  public clientListingUrl = BaseUrlConstantsService.CLIENTS_LISTING;
  clientsList: any = [];
  applyBtn: boolean;
  public deleteInventoryUrl = BaseUrlConstantsService.DELETE_INVENTORY;
  private updateInventoryUrl = BaseUrlConstantsService.UPDATE_INVENTORY;
  public pid: boolean;
  selectedVersion: string;
  public showList: boolean;
  public emptyMsg: boolean;
  public selectValueArr = [];
  selectedInventoryArr: any = [];
  public deviceTypeID: any;
  public deviceTypeName: any;
  public filterSelection = 'All';
  public filterSelectionTwo = 'All';
  public inventoryArrayList: any = [];
  public showEmptyError: any = '';
  public deviceInventoryList: any = [];
  totleInventorysonList: any;
  deviceDetailName: any;
  accociatedClientObj: any;
  pageInfo: any;
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  public allDeviceList: any;
  public associateButtonON: boolean;
  public deviceArrayList: any = [];
  public breadcrumbsArray: any = [{
    page_ref: 'view-device-type',
    page_title: 'device type'
  }, {
    page_ref: 'devices',
    page_title: 'devices'
  }];
  selectionWifiVersion = [];
  public filterList = [{
    title: 'ALL',
    value: '1',
    checked: true
  }, {
    title: 'ASSOCIATED ',
    value: '1',
    checked: false
  }, {
    title: 'UNUSED',
    value: '1',
    checked: false
  }, {
    title: 'REGISTERED',
    value: '1',
    checked: false
  }];
  public filterListTwo = [{
    title: 'ALL',
    value: '1',
    checked: true
  }, {
    title: 'LIVE',
    value: '1',
    checked: false
  }, {
    title: 'HEALTHY',
    value: '1',
    checked: false
  }, {
    title: 'UNHEALTHY',
    value: '1',
    checked: false
  }, {
    title: 'ERROR',
    value: '1',
    checked: false
  }];
  idsResultArr: any = [];
  public today: Date;
  versionsList: any = [];
  clientList: any = [];
  allClients: any = [];
  searchedKey: string = "";
  page = 1;
  count = 0;
  tableSize = 20;

  selectedUserId: any = null;
  // tableSizes = [3, 6, 9, 12];

  public isAllSelected: boolean;


  public tabFwSelected: boolean = true;
  public tabWifiSelected: boolean;
  public IPaddress: any = null;
  public selectedClientId: any = 0;
  public selectedmyValue: boolean = true;

  constructor(
    public router: Router,
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    private formBuilder: FormBuilder) {
    this.isAllSelected = false;
    this.masterSelected = true;
    this.applyBtn = true;
  }


  ngOnInit() {
    this.utcTime();
    this.getAllClients();
    this.getAllInventory(1, this.selectedUserId, this.searchedKey);
    this.getAllVersions("versions");
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }


  beforeChange($event) {
    console.log($event.nextId);

    switch ($event.nextId) {
      case "tab-1":
        this.selectedVersion = undefined;
        this.searchedKey = "";
        this.selectedUserId = null;
        this.tabFwSelected = true;
        this.tabWifiSelected = false;
        this.applyBtn = true;
        this.utcTime();
        this.getAllClients();
        this.getAllInventory(1, this.selectedUserId, this.searchedKey);
        this.getAllVersions("versions");
        break;
      case "tab-2":
        this.selectedVersion = undefined;
        this.searchedKey = "";
        this.selectedUserId = null;
        this.tabFwSelected = false;
        this.tabWifiSelected = true;
        this.applyBtn = true;
        this.utcTime();
        this.getAllClients();
        this.getAllInventory(1, this.selectedUserId, this.searchedKey);
        this.getAllVersions("wifi_versions");
        break;
    }
  }



  async showAllNewInventorys() {
    const body = {
      device_type_id: ''
    };
    this.service.postData(this.inventoryListingUrl, body).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.inventoryArrayList = JSON.parse(JSON.stringify(res)).data.body;
        const newValue = this.inventoryArrayList.filter(result => result.status === 'REGISTERED');
        this.deviceInventoryList = newValue;
        this.totleInventorysonList = this.deviceInventoryList.length;
        if (this.inventoryArrayList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }




  async filterMethod(event) {
    const term = event.toLowerCase();
    this.filterSelection = term;
    this.filterSelectionTwo = 'all';
    if (term === 'all') {
      this.deviceInventoryList = this.inventoryArrayList;
      this.totleInventorysonList = this.deviceInventoryList.length;
    } else {
      const filterValue = this.inventoryArrayList.filter(result => result.status.toLowerCase().indexOf(term) >= 0);
      this.deviceInventoryList = filterValue;
      this.totleInventorysonList = this.deviceInventoryList.length;
    }
  }


  getAllClients() {
    this.service.getData(this.clientListingUrl + "CLIENT").then(async (res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.clientList = JSON.parse(JSON.stringify(res)).data.body;
        if (this.clientList.length !== 0) {
          this.allClients = await this.clientList;
        }
      } else {
        this.service.showError('Something went wrong.');
      }
    }, err => {
      this.changeService.loader(false);
    });
  }

  async filterMethodSecond(event) {
    this.selectedVersion = event;
    if (this.selectedVersion !== 'Select Version') {
      if (this.selectedVersion !== undefined) {
        if (this.selectedInventoryArr.length === 0) {
          this.applyBtn = true;
        } else {
          this.applyBtn = false;
        }
      }
    } else {
      this.applyBtn = true;
    }
  }

  getAllVersions(type) {
    this.versionsList = [];
    this.service.getData(this.getDeviceAllUrl + "?type=" + type).then(res => {
      if (JSON.parse(JSON.stringify(res)).body.data.status === 'success') {
        if (JSON.parse(JSON.stringify(res)).body.data.body.length !== 0) {
          this.versionsList = JSON.parse(JSON.stringify(res)).body.data.body;
        }
      }
    });
  }



  async getDeviceTypeListing() {
    this.service.getData(this.deviceTypeListingUrl + "/" + localStorage.getItem('user_id')).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.deviceArrayList = JSON.parse(JSON.stringify(res)).data.body;
        this.deviceArrayList.unshift({ name: 'All' });
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  onGroupSelected(id) {
    if (id === 0) {
      this.deviceInventoryList = this.inventoryArrayList;
      this.totleInventorysonList = this.deviceInventoryList.length;
    } else {
      this.service.getData(this.inventoryListingUrl + "/" + id).then(res => {
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          const resNew = JSON.parse(JSON.stringify(res)).data.body;
          this.deviceInventoryList = resNew;
        }
      });
    }
  }

  showDeleteDialog(id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: '4000px',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'user'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteInventory(id, index);
      }
    });
  }

  deleteInventory(id, index) {
    this.service.deleteInfo(this.deleteInventoryUrl + "/" + id).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.message.includes("successfully deleted")) {
        this.service.showSuccess('Successfully deleted.');
        this.deviceInventoryList.splice(index, 1);
        this.totleInventorysonList = this.deviceInventoryList.length;
        if (this.deviceInventoryList.length === 0) {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.service.showSuccess('Something went wrong.');
      }
    });
  }

  searchData(ev) {
    if (ev === null) {
      this.searchedKey = "";
      this.getAllInventory(this.page, this.selectedUserId, this.searchedKey);
    } else {
      this.searchedKey = ev.toLowerCase();
    }
  }


  searchExecuteBtn() {
    this.getAllInventory(1, this.selectedUserId, this.searchedKey);
  }

  async editDevice(typeId, name, macAddress, deviceId, deviceUserId) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: typeId,
        deviceTypeName: name,
        deviceMac: macAddress,
        device_user_id: deviceUserId,
        id: deviceId,
        type: 'editInventory'
      }
    };
    this.router.navigate(['/add-device'], navigationExtras);
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  async selectListItem(event: any, index: number, id: number) {
    if (event.checked) {
      this.selectValueArr.push(id);
    } else {
      const index1 = this.selectValueArr.indexOf(id);
      if (index1 > -1) {
        this.selectValueArr.splice(index1, 1);
      }
    }
    if (this.selectValueArr.length === 0) {
      this.associateButtonON = false;
    } else {
      this.associateButtonON = true;
    }
  }

  trackByFn(index, item) {
    return item.id;
  }


  onCheckboxChange(e) {
    if (e.target.checked) {
      this.selectedInventoryArr.push(JSON.parse(e.target.value));
    } else {
      const index = this.selectedInventoryArr.indexOf(JSON.parse(e.target.value));
      if (index > -1) {
        this.selectedInventoryArr.splice(index, 1);
      }
    }
    if (this.selectedVersion !== 'Select Version') {
      if (this.selectedVersion !== undefined) {
        if (this.selectedInventoryArr.length === 0) {
          this.applyBtn = true;
        } else {
          this.applyBtn = false;
        }
      }
    } else {
      this.applyBtn = true;
    }
  }

  checkUncheckAll(e) {
    if (!this.tabFwSelected) {
      let fValue = this.deviceInventoryList.filter(item => item.wifi_installed_version !== null);
      for (let v = 0; v < fValue.length; v++) {
        this.selectionWifiVersion.push(this.deviceInventoryList[v].id);
      }
      if (this.selectionWifiVersion.length === 0) {
        this.isAllSelected = false;
        this.service.showError('No items available for fota in current page.');
      }
    }

    if (e.target.checked) {
      for (var i = 0; i < this.deviceInventoryList.length; i++) {
        this.deviceInventoryList[i].isSelected = true;
        this.selectedInventoryArr.push(this.deviceInventoryList[i].id);
      }
    } else {
      for (var i = 0; i < this.deviceInventoryList.length; i++) {
        this.deviceInventoryList[i].isSelected = false;
      }
      this.selectedInventoryArr = [];
      this.selectionWifiVersion = [];
    }
    if (this.selectedVersion !== 'Select Version') {
      if (this.selectedVersion !== undefined) {
        if (this.selectedInventoryArr.length === 0) {
          this.applyBtn = true;
        } else {
          this.applyBtn = false;
        }
      }
    } else {
      this.applyBtn = true;
    }
  }

  applyVersion() {
    this.isAllSelected = false;
    if(this.IPaddress==null)
        this.selectedClientId =0;
    let body = {
      clientId : this.selectedClientId,
      ipAddress: this.IPaddress,
      ids: this.selectedInventoryArr,
      new_version: this.selectedVersion
    }
    if (!this.tabFwSelected) {
      body["ids"] = this.selectionWifiVersion;
    }
    if (this.tabFwSelected) {
      this.service.postData(this.getDeviceAllUrl + "/update/version", body).then(res => {
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('Updated successfully');
          this.applyBtn = true;
          for (var i = 0; i < this.deviceInventoryList.length; i++) {
            this.deviceInventoryList[i].isSelected = false;
          }
          this.selectedInventoryArr = [];
        } else {
          this.service.showSuccess('Error while updating');
        }
      });
    } else {
      this.service.postData(this.getDeviceAllUrl + "/update/wifi/version", body).then(res => {
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('Updated successfully');
          this.applyBtn = true;
          for (var i = 0; i < this.deviceInventoryList.length; i++) {
            this.deviceInventoryList[i].isSelected = false;
          }
          this.selectedInventoryArr = [];
          this.selectionWifiVersion = [];
        } else {
          this.service.showSuccess('Error while updating');
        }
      });
    }
  }


  getAllInventory(page, userid, searched_key) {
    this.selectedClientId = userid;
    this.isAllSelected = false;
    this.selectedInventoryArr = [];
    this.selectedUserId = userid;
    this.service.getData(this.getDeviceAllUrl + `?type=all&page=${page}&user_id=${userid}&search=${searched_key}`).then(res => {
      if (JSON.parse(JSON.stringify(res)).body.data.status === 'success') {
        this.count = JSON.parse(JSON.stringify(res)).body.data.page.totalItems;
        this.page = JSON.parse(JSON.stringify(res)).body.data.page.currentPage;
        this.tableSize = JSON.parse(JSON.stringify(res)).body.data.page.itemsPerPage;
        if (JSON.parse(JSON.stringify(res)).body.data.body.length !== 0) {
          this.inventoryArrayList = JSON.parse(JSON.stringify(res)).body.data.body;
          for (let a = 0; a < this.inventoryArrayList.length; a++) {
            if (this.isAllSelected) {
              this.inventoryArrayList[a].isSelected = true;
              this.selectedInventoryArr.push(this.inventoryArrayList[a].id);
            } else {
              this.inventoryArrayList[a].isSelected = false;
            }
          }
        } else {
          this.inventoryArrayList = [];
        }
        this.deviceInventoryList = this.inventoryArrayList;
        this.totleInventorysonList = this.deviceInventoryList.length;
        if (this.inventoryArrayList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }


  onTableDataChange(event) {
    this.page = event;
    this.getAllInventory(this.page, this.selectedUserId, this.searchedKey);
  }



  async deviceAssociate() {
    this.service.getData(this.clientListingUrl + "CLIENT").then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.clientsList = JSON.parse(JSON.stringify(res)).data.body;
      }
    });
  }

  async addDevice(typeId, name) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: typeId,
        deviceTypeName: name
      }
    };
    this.router.navigate(['/add-device'], navigationExtras);
  }


  addNewInvenDevice(deviceTypeId: any) {
    if (this.tabFwSelected) {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: '600px',
        height: '300px',
        maxWidth: '100%',
        data: {
          type: 'addDeviceVersionDialogBox',
          inventoryData: { device_version: "", upgrade_url: "", device_type_id: "" }
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          if (result.type === 'addDeviceVersionDialogBox') {
            if (result.inventoryData.upgrade_url === "") {
              this.service.showError("FW file not selected!");
            } else {
                this.getAllVersions("versions");
            }
          };
        };
      });
    } else {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: '300px',
        maxWidth: '100%',
        data: {
          type: 'addWifiVersionDialogBox',
          inventoryData: { device_version: "", upgrade_url: "", device_type_id: "" }
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          if (result.type === 'addWifiVersionDialogBox') {
            if (result.inventoryData.upgrade_url === "") {
              this.service.showError("Wifi file not selected!");
            } else {
                this.getAllVersions("wifi_versions");
            }
          };
        };
      });
    }
  }

  IPAddressFun(){
    this.selectedmyValue = false;
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '300px',
      maxWidth: '100%',
      data: {
        type: 'addIPAddress',
        inventoryData: { ipaddress: '' }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result !== undefined){
        if(result.type === "addIPAddress"){
            this.IPaddress = result.ipaddress;
        }
      }else{
        this.selectedClientId = 0;
        this.selectedmyValue = true;
      }
    })
  }

  deleteFWVersion() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '500px',
      maxWidth: '200%',
      height: '400px',
      maxHeight: '200%',
      data: {
        type: 'deleteFWVersionDialogBox',
        data: { id: "", versions: this.versionsList, selectedTab: this.tabFwSelected }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {

        if (result === "DeletionCompleted") {
          this.getAllVersions("versions");
        } else {
          this.getAllVersions("wifi_versions");
        }
      };
    });
  }


  editInfoNew(obj, i) {
    if (obj.user_id !== "") {
      if (this.clientsList.length !== 0) {
        this.accociatedClientObj = this.clientsList.filter(function (e) {
          return parseInt(e.id) === parseInt(obj.user_id);
        });
      }
    }

    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '300px',
      maxWidth: '100%',
      data: {
        type: 'editNewInventoryDIALOG',
        clients: this.clientsList,
        inventoryData: { device_serial: obj.name, mac_address: obj.mac_address,gateway_url:obj.gateway_url, device_type_id: this.deviceTypeID, client_id: obj.user_id === "" ? "" : obj.user_id, company_name: this.accociatedClientObj.length === 0 ? "" : this.accociatedClientObj[0].company_name }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result.type === 'editNewInventoryDIALOG') {
          const body = {
            user_id: result.inventoryData.client_id,
            device_id: this.deviceTypeID,
            name: result.inventoryData.device_serial,
            mac_address: result.inventoryData.mac_address,
            gateway_url:result.inventoryData.gateway_url,
            status: 'associated'
          };
          this.service.putData(this.updateInventoryUrl + "/" + obj.id, body).then(res => {
            if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
              const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
              this.service.showError(msgErr);
            } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
              this.service.showSuccess('Device association successful.');
              this.getAllInventory(1, this.selectedUserId, this.searchedKey);
            } else {
              this.service.showError('Something went wrong.');
            }
          });
        }
      }
    });
  }
}
